import { TableCell, TableRow } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import Status from '../../UI/status/Status'
import { getUserName } from '../../../helpers/user/UserHelper'
import { getDateAndTimeText } from '../../../helpers/date/dateHelper'
import SupplyBillDeliveryShort from './item/fields/SupplyBillDeliveryShort'
import { statusSupplyBillPaymentText } from '../../../helpers/status/StatusSupplyOrderHelper'
import SupplyBillPaymentShort from './item/fields/SupplyBillPaymentShort'
import SupplyBillCommentsShort from './item/fields/SupplyBillCommentsShort'
import SupplyBillCountItemsShort from './item/fields/SupplyBillCountItemsShort'
import SupplyBillNakladnaItemsShort from './item/fields/SupplyBillNakladnaItemsShort'
import MyTableCheckBox from '../../UI/table/MyTableCheckBox'
import { editSupplyBillsChecked, setSupplyBillsChecked } from '../../../store/supplyBillSlice'
import { useDispatch, useSelector } from 'react-redux'
import SupplyBillPriceGeneral from '../supplyBill/view/about/price/SupplyBillPriceGeneral'
import SupplyBillAgreesCount from './item/fields/agree/SupplyBillAgreesCount'
import SupplierContactsShort from '../supplier/view/contacts/short/SupplierContactsShort'
import InnerTable from '../../UI/table/inner/InnerTable'
import { useState } from 'react'
import SupplyBillItemsTableShort from '../supplyBill/view/itemsShort/SupplyBillItemsTableShort'
import MyTableMoreIco from '../../UI/table/MyTableMoreIco'
import { currencyText } from '../../../helpers/unitMeasure/UnitMeasureHelper'

const SupplyBillItem = ({ supplyBill }) => {

	const user = useSelector(state => state.user.user)
	const checked = useSelector(state => state.supplyBill.supplyBills.checked)
	const dispatch = useDispatch()

	const [open, setOpen] = useState(false)

	// setSupplyBillsChecked

  return (
	<>
		<TableRow>
			<MyTableCheckBox
				id={supplyBill.id}
				// checked={checked}
				// setChecked={setChecked}
				checked={checked}
				setChecked={e => dispatch(editSupplyBillsChecked(e))}
				isReturnValues={true}
				// setChecked={e => console.log('e', e)}
			/>
			<MyTableMoreIco
				open={open}
				setOpen={setOpen}
			/>
			<TableCell align='center'>
				<Link to={`/supply/bills/${supplyBill.id}`}>
					{supplyBill.id}
				</Link>
				{/* {supplyOrder.id} */}
			</TableCell>
			<TableCell align='center'>
				{
					<Status status={supplyBill.status} />
					// supplyOrder.status
				}
			</TableCell>
			<TableCell align='center'>
				{
					getDateAndTimeText(supplyBill.createdAt)
				}
			</TableCell>
			<TableCell align='center'>
				{
					getUserName({
						user: supplyBill.user
					})
				}
			</TableCell>
			<TableCell align='center'>
				{
					supplyBill.supplier ?  
						<>
							<Link to={`/supply/suppliers/${supplyBill.supplier.id}`}>
								{supplyBill.supplier.name}
							</Link>
							<SupplierContactsShort
								contacts={supplyBill.supplier.contacts}
							/>
						</>
					: ''
				}
			</TableCell>
			<TableCell align='center'>
				<SupplyBillPriceGeneral
					priceAgree={supplyBill.priceAgree}
				/>
				{
					user && (user.role === 'SUPERADMIN' || user.role === 'ADMIN') ?
						supplyBill.maxItem ? 
							<p className='wordBreakAll mw200'>
								{supplyBill.maxItem.nameInBill}
							</p>
						: ''
					: ''
				}
			</TableCell>
			<TableCell align='center'>
				<SupplyBillAgreesCount 
					supplyBill={supplyBill}
				/>
			</TableCell>
			<TableCell align='center'>
				<SupplyBillPaymentShort 
					payments={supplyBill.payments}
				/>
			</TableCell>
			<TableCell align='center'>
				<SupplyBillDeliveryShort 
					deliveries={supplyBill.deliveries}
				/>
			</TableCell>
			<TableCell align='center'>
				<SupplyBillCommentsShort 
					comments={supplyBill.comments}
				/>
				<SupplyBillCountItemsShort 
					items={supplyBill.items}
				/>
				<SupplyBillNakladnaItemsShort 
					supplyBill={supplyBill}
				/>
			</TableCell>
			{/* <TableCell align="center" className='myTable__actions'>
				
			</TableCell> */}
		</TableRow>

		<InnerTable
			open={open}
		>
			<SupplyBillItemsTableShort 
				supplyBillItems={supplyBill.items}
			/>
		</InnerTable>
	</>
  )
}

export default SupplyBillItem